<script>
import { BToast } from "bootstrap-vue";

export default {
  extends: BToast
};
</script>